/* eslint-disable react/jsx-curly-newline */
import React from 'react';

import PropTypes from 'prop-types';

import Fade from '@material-ui/core/Fade';
import { connect, useSelector } from 'react-redux';

import Icons from 'consts/icons';

import { hasObjectKeys } from 'utils/main';

import Ruler from './Ruler';
import { useStyles } from './DashboardFiltersMenuUseStyles';
import FiltersDetails from './FiltersDetails';

const DashboardFiltersMenu = props => {
  const {
    setZonesFilters,
    map,
    setFiltersOption,
    setZonesCategoriesFilters,
    zonesCategoriesFilters,
  } = props;
  const [showOption, setShowOption] = React.useState({
    source: false,
    zones: false,
    public: false,
    ruler: false,
    map: false,
  });
  const [showMeasure, setShowMeasure] = React.useState(false);
  const [clickEvent, setClickEvent] = React.useState(null);
  const [items, setItems] = React.useState([]);
  const [details, setDetails] = React.useState(null);

  const useString = () => {
    const language = useSelector(state => state.language);

    return language;
  };
  const subtitles = useString().filtersMenuIcons;

  const initMap = () => {
    if (!hasObjectKeys(map)) return;
    map.on('click', setClickEvent);

    return () => cleanup();
  };

  React.useEffect(initMap, [map]);

  const cleanup = () => {
    map.un('click', setClickEvent);
  };

  const handleMapClick = () => {
    if (!clickEvent) return;
    if (!showMeasure) {
      setShowOption({
        source: false,
        zones: false,
        public: false,
        ruler: false,
        map: false,
      });
      setDetails(null);
    }
  };

  React.useEffect(handleMapClick, [clickEvent]);

  const handleOption = option => {
    if (option === details) {
      handleCloseAll();
    } else {
      const arr = Object.keys(showOption);
      setShowMeasure(false);
      setShowOption({
        ...showOption,
        source: false,
        zones: false,
        public: false,
        ruler: false,
        map: false,
        [option]: true,
      });
      if (option !== 'map') setFiltersOption(arr.indexOf(option));
      if (option === 'ruler') setShowMeasure(true);
      setDetails(option);
    }
  };

  const handleCloseAll = () => {
    setShowMeasure(false);
    setShowOption({
      source: false,
      zones: false,
      public: false,
      ruler: false,
      map: false,
    });
    setDetails(null);
  };

  React.useEffect(() => {
    setItems([
      {
        name: 'source',
        icon: <Icons.DashboardMenu.Source />,
      },
      {
        name: 'zones',
        icon: <Icons.DashboardMenu.Map />,
      },
      {
        name: 'public',
        icon: <Icons.DashboardMenu.Public />,
      },
      {
        name: 'ruler',
        icon: <Icons.DashboardMenu.Ruler />,
      },
      {
        name: 'map',
        icon: <Icons.DashboardMenu.EditMap />,
      },
    ]);
  }, []);
  const classes = useStyles();

  return (
    <>
      <div className={classes.DashboardFiltersMenu}>
        <div className={`${classes.DashboardFiltersMenu}__nav`}>
          <div className={`${classes.DashboardFiltersMenu}__nav__list`}>
            {items?.map((item, index) => (
              <div
                key={`${index}-${item.name}`}
                className={`${classes.DashboardFiltersMenu}__nav__list__item ${
                  Object.values(showOption)[index] ? 'active' : ''
                }`}
                onClick={() => handleOption(Object.keys(showOption)[index])}
                aria-hidden="true"
              >
                <div
                  className={`${classes.DashboardFiltersMenu}__nav__list__item__icon`}
                >
                  {item.icon}
                </div>
                <span
                  className={`${classes.DashboardFiltersMenu}__nav__list__item__text`}
                >
                  {subtitles[item.name]}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Fade in={details !== null}>
        <div>
          <FiltersDetails
            details={details}
            setZonesFilters={setZonesFilters}
            setZonesCategoriesFilters={setZonesCategoriesFilters}
            zonesCategoriesFilters={zonesCategoriesFilters}
          />
        </div>
      </Fade>
      {details === 'ruler' ? <Ruler /> : null}
    </>
  );
};

DashboardFiltersMenu.propTypes = {
  setZonesFilters: PropTypes.func.isRequired,
  map: PropTypes.object.isRequired,
  setFiltersOption: PropTypes.func,
  setZonesCategoriesFilters: PropTypes.func.isRequired,
  zonesCategoriesFilters: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
  map: state.map,
});

export default connect(mapStateToProps)(DashboardFiltersMenu);
